"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodStep = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var checkout_1 = require("../../../../api/calls/basket/checkout");
var paygate_checkout_1 = require("../../../../api/calls/payment-engine/paygate/paygate_checkout");
var basket_1 = require("../../../../reducers/slices/basket/basket");
var checkout_2 = require("../../../../reducers/slices/checkout");
var main_1 = require("../../../../reducers/slices/main");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var apply_voucher_1 = require("../../../../api/calls/basket/apply_voucher");
var PaymentMethodStep = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var cookie = new universal_cookie_1.default();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.checkoutState; }), currentCheckoutStep = _a.currentCheckoutStep, selectedBankCard = _a.selectedBankCard, deliveryOrCollection = _a.deliveryOrCollection, selectedAddress = _a.selectedAddress;
    var basket = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).basket;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)(false), saveBankCard = _b[0], setSaveBankCard = _b[1];
    var _c = (0, react_1.useState)(null), formData = _c[0], setFormData = _c[1];
    var formRef = (0, react_1.useRef)();
    var _d = (0, react_1.useState)(false), payFormLoading = _d[0], setPayFormLoading = _d[1];
    var _e = (0, react_1.useState)(false), voucherButtonLoading = _e[0], setVoucherButtonLoading = _e[1];
    var _f = (0, react_1.useState)([]), basketDeals = _f[0], setBasketDeals = _f[1];
    //Voucher Details
    var _g = (0, react_1.useState)(false), isModalOpen = _g[0], setIsModalOpen = _g[1];
    var _h = (0, react_1.useState)(false), voucherSelected = _h[0], setVoucherSelected = _h[1];
    var _j = (0, react_1.useState)(0), checkoutAmount = _j[0], setCheckoutAmount = _j[1];
    var _k = (0, react_1.useState)(""), voucherCode = _k[0], setVoucherCode = _k[1];
    var _l = (0, react_1.useState)(""), voucherCodeErrorText = _l[0], setVoucherCodeErrorText = _l[1];
    (0, react_1.useEffect)(function () {
        if (formData) {
            /* dispatch(
              set_checkout_cookie_thunk({
                usedVaultedCard: selectedBankCard && true,
                deals: basketDeals.length > 0 ? basketDeals : null,
                discount: `${basket?.product_list?.reduce((sum: any, product: any) => sum + (product.deal ? product.deal.discount : 0), 0)}`,
                checkoutAmount: `${parseFloat(checkoutAmount).toFixed(2)}`,
                paymentReference: formData.REFERENCE,
                   delivery_fee: basket.delivery_fee,
              }),
            );
            */
            formRef.current.submit();
        }
    }, [formData]);
    var onPrevious = function () {
        var previousStep = currentCheckoutStep - 1;
        if (currentCheckoutStep > 0) {
            dispatch((0, checkout_2.setCurrentCheckoutStep)(previousStep));
        }
    };
    (0, react_1.useEffect)(function () {
        init();
    }, [basket]);
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var totalAmount;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    totalAmount = (_a = (basket === null || basket === void 0 ? void 0 : basket.outstanding_amount).toString()) !== null && _a !== void 0 ? _a : (basket === null || basket === void 0 ? void 0 : basket.total).toString();
                    setPayFormLoading(true);
                    return [4 /*yield*/, setCheckoutAmount(totalAmount)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, setPayFormLoading(false)];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var ApplyVoucher = function () {
        if (!voucherCode) {
            setVoucherCodeErrorText("Please enter a voucher code");
        }
        else {
            setVoucherButtonLoading(true);
            (0, apply_voucher_1.apply_voucher)({
                code: voucherCode,
                basket_id: basket._id,
            }).then(function (response) {
                if (response.success) {
                    setVoucherButtonLoading(false);
                    dispatch((0, basket_1.get_basket_thunk)());
                    setIsModalOpen(false);
                }
                else {
                    setVoucherButtonLoading(false);
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong", messages: [response.message] }));
                }
            });
        }
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 items-start w-full" },
        (basket === null || basket === void 0 ? void 0 : basket.vouchers) && (basket === null || basket === void 0 ? void 0 : basket.vouchers.length) > 0 ? (react_1.default.createElement("div", { className: "flex flex-col gap-4  w-full" },
            basket &&
                basket.vouchers.map(function (voucher, index) {
                    var _a, _b;
                    return (react_1.default.createElement("div", { key: index, className: "flex flex-row p-4 border border-success rounded-lg justify-  w-full", onClick: function () {
                            setIsModalOpen(true);
                        } },
                        react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: voucher.type === "PERCENTAGE"
                                    ? "".concat(voucher.voucher_code, " - ").concat(voucher.discount, "% Off")
                                    : "".concat(voucher.voucher_code, " - ").concat(doshx_controls_web_1.Utilities.formatMoney({
                                        value: (_b = (_a = voucher.discount) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0",
                                        decimalPlaces: 2,
                                    }), " Off"), className: "cursor-pointer" //
                                , textColor: "text-black" })),
                        react_1.default.createElement("div", { className: "rounded-lg bg-primary px-2 py-1 flex flex-row items-center" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Applied!", className: "cursor-pointer" //
                                , textColor: "text-white", size: "xsmall" }))));
                }),
            react_1.default.createElement("div", { className: "flex flex-row items-center  justify-evenly  w-full mb-16", onClick: function () {
                    setIsModalOpen(true);
                } },
                react_1.default.createElement("div", { className: "rounded-md bg-success px-2 py-1  flex flex-row items-center" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Apply More Vouchers", className: "cursor-pointer" //
                        , textColor: "text-white", size: "xsmall" }))))) : (react_1.default.createElement("div", { className: "flex flex-row items-center p-4 border border-success rounded-lg justify-evenly  w-full", onClick: function () {
                setIsModalOpen(true);
            } },
            react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "No voucher selected", className: "cursor-pointer" //
                    , textColor: "text-black" })),
            react_1.default.createElement("div", { className: "rounded-lg bg-primary px-2 py-1 flex flex-row items-center" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Apply Now", className: "cursor-pointer" //
                    , textColor: "text-white", size: "xsmall" })))),
        formData && (react_1.default.createElement("form", { ref: formRef, action: process.env.PAYGATE_FORM_URL, method: "post" //
            , className: "hidden" }, Object.keys(formData).map(function (key, index) {
            return react_1.default.createElement("input", { key: "form-hidden-field-".concat(index), type: "hidden", name: key, value: formData[key] });
        }))),
        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            !selectedBankCard && (react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Save the card for future purchases?", checkedColor: "text-primary", uncheckedColor: "text-primary", value: saveBankCard, onChange: function (v) {
                    setSaveBankCard(v);
                } })),
            react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "PAY WITH PAYGATE", loading: payFormLoading, backgroundColor: "bg-primary", onClick: function () {
                        var _a, _b, _c, _d, _e, _f;
                        if (selectedBankCard) {
                            var request = {
                                basket_id: basket._id,
                                type: "delivery",
                                card: {
                                    _id: selectedBankCard.id,
                                },
                            };
                            setPayFormLoading(true);
                            (0, checkout_1.checkout_basket)(request).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                var _a, _b, _c, _d, _e;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            setPayFormLoading(false);
                                            if (!response.success) return [3 /*break*/, 2];
                                            // navigate("/basket");
                                            return [4 /*yield*/, dispatch((0, basket_1.set_checkout_cookie_thunk)({
                                                    delivery_fee: basket.delivery_fee,
                                                    paymentReference: (_d = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.transaction_details) === null || _c === void 0 ? void 0 : _c.transaction) === null || _d === void 0 ? void 0 : _d.ref,
                                                    usedVaultedCard: selectedBankCard && true,
                                                    discount: "".concat((_e = basket === null || basket === void 0 ? void 0 : basket.product_list) === null || _e === void 0 ? void 0 : _e.reduce(function (sum, product) { return sum + (product.deal ? product.deal.discount : 0); }, 0)),
                                                    checkoutAmount: "".concat(parseFloat(checkoutAmount).toFixed(2)),
                                                }))];
                                        case 1:
                                            // navigate("/basket");
                                            _f.sent();
                                            // dispatch(get_basket_thunk());
                                            navigate("/outcome/success");
                                            return [3 /*break*/, 3];
                                        case 2:
                                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while checking out!", messages: [response.message] }));
                                            _f.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        else {
                            var url = window.location.origin;
                            setPayFormLoading(true);
                            (0, paygate_checkout_1.paygate_checkout)({
                                basket_id: basket._id,
                                amount: parseFloat(checkoutAmount).toFixed(2),
                                email: (_a = user.email) !== null && _a !== void 0 ? _a : "",
                                integration_id: (_b = user._id) !== null && _b !== void 0 ? _b : "",
                                customer_title: "N/A",
                                customer_name: (_c = user.name) !== null && _c !== void 0 ? _c : "",
                                customer_lastname: (_d = user.surname) !== null && _d !== void 0 ? _d : "",
                                customer_mobile: (_e = user.cell_number) !== null && _e !== void 0 ? _e : "",
                                customer_telephone: (_f = user.cell_number) !== null && _f !== void 0 ? _f : "",
                                return_url: "".concat(url, "/outcome/success"),
                                vault_card: saveBankCard ? 1 : 0,
                            }).then(function (response) {
                                var _a, _b;
                                setPayFormLoading(false);
                                if (response.success) {
                                    dispatch((0, basket_1.set_checkout_cookie_thunk)({
                                        delivery_fee: basket.delivery_fee,
                                        paymentReference: (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.REFERENCE,
                                        usedVaultedCard: false,
                                        discount: "".concat((_b = basket === null || basket === void 0 ? void 0 : basket.product_list) === null || _b === void 0 ? void 0 : _b.reduce(function (sum, product) { return sum + (product.deal ? product.deal.discount : 0); }, 0)),
                                        checkoutAmount: "".concat(parseFloat(checkoutAmount).toFixed(2)),
                                    }));
                                    setFormData(response.content);
                                    // here, `checkout_basket` would be called in `outcome.tsx`
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Could not generate PayGate form!", messages: [response.message] }));
                                }
                            });
                        }
                    } }),
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                        onPrevious();
                    } }))),
        react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: "Apply Voucher", open: isModalOpen, onClose: function () {
                setIsModalOpen(false);
            } },
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Choose from the available vouchers below to apply discount:" }),
                react_1.default.createElement("div", { className: "flex items-center" },
                    react_1.default.createElement("hr", { className: "flex-grow border-t-2 border-gray-200 mr-2" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { center: true, label: "OR" }),
                    react_1.default.createElement("hr", { className: "flex-grow border-t-2 border-gray-200 ml-2" })),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Enter Code", size: "small", value: voucherCode, errorTextColor: "text-red-500", errorText: voucherCodeErrorText, onChange: function (v) {
                        setVoucherCode(v);
                    } }),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Apply", backgroundColor: "bg-success", size: "xsmall", loading: voucherButtonLoading, onClick: function () {
                        ApplyVoucher();
                        //setVoucherSelected(true);
                        //setIsModalOpen(false);
                    } })))));
};
exports.PaymentMethodStep = PaymentMethodStep;
